module.exports = __webpack_public_path__ + "img/3x.9ab7f19.jpg";